import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "ta-e" };
const _hoisted_3 = { class: "ta-e" };
const _hoisted_4 = { class: "ta-e" };
const _hoisted_5 = { class: "ta-e" };
const _hoisted_6 = { class: "ta-c" };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { class: "ta-c" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_text_field = _resolveComponent("v-text-field");
    return (!_ctx.isItemEditItem)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
            _createCommentVNode(" 상품 요금 시작 금액 "),
            _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.displayOrderAmountStart), 1 /* TEXT */),
            _createCommentVNode(" 상품 요금 종료 금액 "),
            _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.displayOrderAmountEnd), 1 /* TEXT */),
            _createCommentVNode(" 할증 금액 "),
            _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.displaySurcharge), 1 /* TEXT */),
            _createCommentVNode(" 할증 퍼센트 "),
            _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.displaySurchargeRate), 1 /* TEXT */),
            _createCommentVNode(" 상품가 할증 설정 "),
            _createElementVNode("td", _hoisted_6, [
                _createCommentVNode(" 수정 "),
                _createVNode(_component_v_btn, {
                    icon: "mdi-pencil-outline",
                    variant: "text",
                    color: "black",
                    disabled: _ctx.isClickDisabled,
                    onClick: _withModifiers(_ctx.handleClickEditBtn, ["stop"])
                }, null, 8 /* PROPS */, ["disabled", "onClick"]),
                _createCommentVNode(" 삭제 "),
                _createVNode(_component_v_btn, {
                    icon: "mdi-trash-can-outline",
                    variant: "text",
                    color: "black",
                    disabled: _ctx.isClickDisabled,
                    onClick: _withModifiers(_ctx.handleClickDeleteBtn, ["stop"])
                }, null, 8 /* PROPS */, ["disabled", "onClick"])
            ])
        ]))
        : (_openBlock(), _createElementBlock("tr", _hoisted_7, [
            _createElementVNode("td", null, [
                _createCommentVNode(" 상품 요금 시작 금액 "),
                _createVNode(_component_v_text_field, {
                    ref: _ctx.formRefs.orderAmountStart,
                    modelValue: _ctx.formattedOrderAmountStart,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formattedOrderAmountStart) = $event)),
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "auto",
                    dense: "",
                    reverse: "",
                    maxlength: _ctx.STORE_ORDER_AMOUNT_MAX_LENGTH,
                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                    error: _ctx.isDuplicatedError,
                    rules: _ctx.formRules.orderAmountStart
                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "error", "rules"])
            ]),
            _createElementVNode("td", null, [
                _createCommentVNode(" 상품 요금 종료 금액 "),
                _createVNode(_component_v_text_field, {
                    ref: _ctx.formRefs.orderAmountEnd,
                    modelValue: _ctx.formattedOrderAmountEnd,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.formattedOrderAmountEnd) = $event)),
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "auto",
                    dense: "",
                    reverse: "",
                    maxlength: _ctx.STORE_ORDER_AMOUNT_MAX_LENGTH,
                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                    error: _ctx.isDuplicatedError,
                    rules: _ctx.formRules.orderAmountEnd
                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "error", "rules"])
            ]),
            _createElementVNode("td", null, [
                _createCommentVNode(" 할증 금액 "),
                _createVNode(_component_v_text_field, {
                    ref: _ctx.formRefs.surcharge,
                    modelValue: _ctx.formattedSurcharge,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formattedSurcharge) = $event)),
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "auto",
                    dense: "",
                    reverse: "",
                    maxlength: _ctx.STORE_SURCHARGE_MAX_LENGTH,
                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                    prefix: _ctx.$t('common.currency'),
                    rules: _ctx.formRules.surcharge
                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "prefix", "rules"])
            ]),
            _createElementVNode("td", null, [
                _createCommentVNode(" 할증 퍼센트 "),
                _createVNode(_component_v_text_field, {
                    ref: _ctx.formRefs.surchargeRate,
                    modelValue: _ctx.formattedSurchargeRate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.formattedSurchargeRate) = $event)),
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "auto",
                    dense: "",
                    reverse: "",
                    maxlength: _ctx.STORE_SURCHARGE_RATE_MAX_LENGTH,
                    oninput: "javascript: this.value = this.value.replace(/[^0-9|.]/g, '' );",
                    prefix: _ctx.$t('unit.percent'),
                    rules: _ctx.formRules.surchargeRate
                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "prefix", "rules"])
            ]),
            _createElementVNode("td", _hoisted_8, [
                _createCommentVNode(" 수정 완료 "),
                _createVNode(_component_v_btn, {
                    icon: "mdi-check",
                    variant: "text",
                    color: "blue",
                    density: "comfortable",
                    onClick: _withModifiers(_ctx.handleClickSubmitEditBtn, ["stop"])
                }, null, 8 /* PROPS */, ["onClick"]),
                _createCommentVNode(" 수정 취소 "),
                _createVNode(_component_v_btn, {
                    icon: "mdi-close",
                    variant: "text",
                    color: "black",
                    density: "comfortable",
                    onClick: _withModifiers(_ctx.handleClickCancelEditBtn, ["stop"])
                }, null, 8 /* PROPS */, ["onClick"])
            ])
        ]));
}
